/*
 * @Author: chenguanghua
 * @Date: 2022-07-025 16:58:32
 * @LastEditors: DQL
 * @LastEditTime: 2022-10-24 18:27:19
 * @Description: 维保报告信息
 */
/* 路由配置说明
  name: 'xfwbrouter-name' // 设定路由的名字，要求唯一性
  webpackChunkName: "wbsysMenu" // 设置打包模块，要求名称与name一致，唯一性
  meta: {
    navtabTitle: '' // 设置该路由navtabTitle为stringf或者function
    isCache: true  // 设置页面需要缓存，再次打开页面不刷新数据，默认false，设为true缓存页面
    ignoreDiff: [] // 设置判断页面是否相同需忽略的参数，判断处理时默认忽略isRefresh参数，因此isRefresh不需在此设置
    isSecondary: true  // 页面为父页面的一个小页面，不需要展示在tab上作为一个tab页面展示，设置为true，默认false
    isIframe: false // 是否为iframe页面
  }
*/
const bgglRoutes = {
  path: 'bggl',
  name: 'xfwbbggl',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'dscbg',
      name: 'xfwbdsc',
      component: () => import(/* webpackChunkName: "xfwbdsc" */ '@/features/xfwbgl/bggl/dscbg.vue'),
      meta: {
        navtabTitle: '待生成报告',
        isCache: true,
        ignoreDiff: [],
        isSecondary: false
      }
    },
    {
      path: 'dgz',
      name: 'xfwbdgz',
      component: () => import(/* webpackChunkName: "xfwbdgz" */ '@/features/xfwbgl/bggl/index.vue'),
      meta: {
        navtabTitle: '待盖章',
        isCache: true,
        ignoreDiff: [],
        isSecondary: false,
        menuElements: [
          { elementCode: 'wbxm_gz', elementName: '盖章' }
        ]
      }
    },
    {
      path: 'ygz',
      name: 'xfwbygz',
      component: () => import(/* webpackChunkName: "xfwbygz" */ '@/features/xfwbgl/bggl/index.vue'),
      meta: {
        navtabTitle: '已盖章',
        isCache: true,
        ignoreDiff: [],
        isSecondary: false
      }
    },
    {
      path: 'yzf',
      name: 'xfwbyzf',
      component: () => import(/* webpackChunkName: "xfwbyzf" */ '@/features/xfwbgl/bggl/index.vue'),
      meta: {
        navtabTitle: '已作废',
        isCache: true,
        ignoreDiff: [],
        isSecondary: false
      }
    },
    {
      path: 'all',
      name: 'xfwbsybg',
      component: () => import(/* webpackChunkName: "xfwbsybg" */ '@/features/xfwbgl/bggl/index.vue'),
      meta: {
        navtabTitle: '所有报告',
        isCache: true,
        ignoreDiff: [],
        isSecondary: false,
        menuElements: [
          { elementCode: 'wbxmManage_search', elementName: '查询' },
          { elementCode: 'wbxm_scbg_ls', elementName: '生成临时报告' },
          { elementCode: 'wbxm_scbg', elementName: '生成报告' },
          { elementCode: 'wbxm_sqxg', elementName: '申请修改' },
          { elementCode: 'wbxm_gz', elementName: '盖章' }
        ]
      }
    },
    {
      path: 'sjts',
      name: 'xfwbbgts',
      component: () => import(/* webpackChunkName: "xfwbbgts" */ '@/features/xfwbgl/bggl/wbbgts.vue'),
      meta: {
        navtabTitle: '维保报告推送',
        isCache: true,
        ignoreDiff: [],
        isSecondary: false
      }
    }
  ]
};

export default bgglRoutes;
